import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const Wallet = ({ width = 14, height = 14 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 14 14"
  >
    <g clipPath="url(#clip0_399_3482)">
      <path
        d="M12.25 2.3335H1.75001C1.10568 2.3335 0.583344 2.85583 0.583344 3.50016V10.5002C0.583344 11.1445 1.10568 11.6668 1.75001 11.6668H12.25C12.8943 11.6668 13.4167 11.1445 13.4167 10.5002V3.50016C13.4167 2.85583 12.8943 2.3335 12.25 2.3335Z"
        stroke="#52575C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.583344 5.8335H13.4167"
        stroke="#52575C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_399_3482">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
